<style src="./../styles/bootstrap.css"></style>
<style src="./../styles/DFStyle_Master.css"></style>
<style src="./../icons/style.css"></style>
<style src="./../styles/jquery-ui.css"></style>
<style lang="less" src="./../styles/DFStyle_Site_Template.less"></style>
<template>
    <Promised :pending-delay="null" :promise="siteDesignStylesUrl!" v-slot:combined="{ data }">
        <link rel="stylesheet" :href="data" @load="$emit('load')" />
    </Promised>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { Promised } from "@/lib/Promised";
export default defineComponent({
    emits: ["load"],
    components: {
        Promised,
    },
    props: {
        siteDesignStylesUrl: Promise<string>,
    },
});
</script>
